import { style } from 'styled-system'; // null could be value which is used to not have offset within a resopnsive ruleset

export const toPercent = value => typeof value === 'number' ? `${value * 100}%` : value;
export const offset = style({
  prop: 'offset',
  cssProperty: 'marginLeft',
  transformValue: props => toPercent(props)
});